import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";

import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import LookDropdown from "../../../ui/lookDropdown";
import {getAddressFromObject} from "../../../../popups/printPopup/printDocumentInfo";
import {setPaymentInfo} from "../../../../../actions/paymentFunctions";
import {ROUTES} from "../../../../../routes";


const GroheCartShippingDropdown = (props) => {

  const {userInfo, shippingAddress, setPaymentInfo, intl, history} = props;

  const changeAddressClick = () => {
    history.push(ROUTES.cartShipping);
  }

  const addresses = [];

  if (shippingAddress.address1 || shippingAddress.city) {
    addresses.push({
      text: getAddressFromObject(shippingAddress, true),
      value: 0,
    })
  }

  if (userInfo.address1 || userInfo.city) {
    addresses.push({
      text: getAddressFromObject(userInfo, true),
      value: 1,
    })
  }

  return (
    <Fragment>
      <GroheCartHeaderCommon title="grohe.cart.billing.shipping.title"
                             subTitle="grohe.cart.billing.shipping.subTitle"
                             className="gc-header--small-bottom"/>
      <div className="gc-content">
        <LookDropdown className="gc-select"
                      textOnly={true}
                      selectLabel={intl.formatMessage({id: "grohe.cart.billing.address"}) + ":"}
                      selectItems={addresses}
                      selectedItem={addresses[0]}
                      selectItemClick={(selectItem, selectItemIndex) => setPaymentInfo("selectedShippingAddressIndex", selectItemIndex)}/>
        <div className="gc-content__change">
          <Button className="look-button--no-bg look-button--text look-button--no-transform nowrap"
                  startIcon={<EditIcon/>}
                  onClick={changeAddressClick}>
            <FormattedMessage id={
              shippingAddress.address1 || shippingAddress.city ? "grohe.cart.billing.changeAddress" : "grohe.cart.billing.addNewAddress"
            }/>
          </Button>
        </div>
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {userInfo} = store.userState;
  const {shippingAddress} = store.paymentState;

  return {
    isMobile,
    userInfo,
    shippingAddress,
  };
};

const mapDispatchToProps = {
  setPaymentInfo,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartShippingDropdown)
  )
)
